<template>
  <v-container class="page has-fab">
    <Toolbar :title="$vuetify.breakpoint.xsOnly ? $t('message.your_orders') : null" />
    <GenericError v-if="error" />
    <v-card outlined :loading="loading">
      <v-card-title class="grey lighten-4">
        <span>
          SD-WAN
        </span>
        <v-spacer />
      </v-card-title>
      <template v-if="loading">
        <v-row align="center" justify="center" no-gutters style="min-height: 100px">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      </template>
      <v-card-text v-else-if="siteVpns && siteVpns.length === 0" class="text-center my-12">
        <v-icon color="grey lighten-2" size="100px">mdi-account-network-off-outline</v-icon>
        <h1 class="headline">No SD-WAN</h1>
        <p class="subheading">SD-WAN is not configured for this site.</p>
      </v-card-text>
      <v-card-text v-else-if="error">
        <v-alert type="error" prominent>
          Failed to retrieve SD-WAN information.
        </v-alert>
      </v-card-text>

      <v-tabs v-else v-model="tab" background-color="grey lighten-4">
        <v-tab v-for="siteVpn in visibleSiteVpns" :key="siteVpn['@id']">{{ siteVpn.alias || siteVpn.address }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="siteVpn in siteVpns" :key="siteVpn['@id']">
          <v-row no-gutters>
            <v-col>
              <SiteVpnCard :site-vpn="siteVpn" :site="site" />
            </v-col>
          </v-row>
          <SiteVpnMikrotik :site-vpn="siteVpn" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
import fetch from '@/utils/fetch'
import SiteVpnMikrotik from '@/components/Vpn/SiteVpnMikrotik.vue'
import Toolbar from '@/components/Toolbar.vue'
import SiteVpnCard from '@/components/Vpn/SiteVpnCard.vue'

export default {
  name: 'SiteVpn',
  components: { SiteVpnCard, Toolbar, SiteVpnMikrotik },
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      siteVpns: [],
      vpnUsers: [],
      siteId: null,
      loading: false,
      error: null,
      enabled: false,
      fileLoading: false,
      statusLoading: false,
      newAlias: '',
      tab: null
    }
  },
  computed: {
    visibleSiteVpns() {
      return this.siteVpns.filter(siteVpn => !siteVpn.hidden)
    }
  },

  mounted() {
    this.siteId = this.$route.params.id
    this.fetchSiteVpnsBySite()
  },
  methods: {
    fetchSiteVpnsBySite() {
      this.loading = true
      fetch('/site_vpns?site=' + this.siteId)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.siteVpns = data['hydra:member']
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loading = false
        })
    },

    createVpnUser() {
      this.loading = true

      fetch('/sites/' + this.$iriToId(this.siteId) + '/vpn/user', {
        method: 'POST',
        body: JSON.stringify({})
      })
        .then(response => {
          return response.json()
        })
        .then(data => {
          data.enabled = data.status !== 'Disabled'
          this.vpnUsers.push(data)
          this.fetchSiteVpnsBySite()
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
